// Default catalog configuration for the miyogur app
export const DEFAULT_CATALOG = {
  sizes: [
    { id: "200", label: "200 g", allowedToppings: ["arandanos", "arandanospasa", "banana", "nueces", "canela", "tiramisu", "tortadelimon"] },
    { id: "300", label: "300 g", allowedToppings: ["arandanos", "arandanospasa", "banana", "nueces", "canela", "tiramisu", "tortadelimon"] },
    { id: "700", label: "700 g", allowedToppings: [] },
  ],
  flavors: [
    {
      id: "natural",
      label: "Griego natural",
      desc: "Griego clásico, levemente dulce",
      imageUrl: "/images/flavors/optimized/natural.webp",
      defaultAcidezIndex: 0,
      defaultTexturaIndex: 1,
      defaultGrasasIndex: 2,
      toppings: [],
    },
    {
      id: "descremado",
      label: "Griego descremado",
      desc: "Griego descremado, levemente dulce",
      imageUrl: "/images/flavors/optimized/descremado.webp",
      defaultAcidezIndex: 0,
      defaultTexturaIndex: 1,
      defaultGrasasIndex: 0,
      toppings: [],
    },
    {
      id: "postrecito",
      label: "Postrecito",
      desc: "Arándanos, nueces y canela",
      imageUrl: "/images/flavors/optimized/postrecito.webp",
      defaultAcidezIndex: 0,
      defaultTexturaIndex: 1,
      defaultGrasasIndex: 1,
      toppings: ["arandanos", "nueces", "canela"],
    },
    {
      id: "tiramisu",
      label: "Tiramisú",
      desc: "Plantillas y café",
      imageUrl: "/images/flavors/optimized/tiramisu.webp",
      defaultAcidezIndex: 1,
      defaultTexturaIndex: 0,
      defaultGrasasIndex: 1,
      toppings: ["tiramisu"]
    },
    {
      id: "tortadelimon",
      label: "Torta de limón",
      desc: "Plantillas y limón",
      imageUrl: "/images/flavors/optimized/lemonpie.webp",
      defaultAcidezIndex: 1,
      defaultTexturaIndex: 0,
      defaultGrasasIndex: 1,
      toppings: ["tortadelimon"]
    },
  ],
  toppings: [
    { id: "arandanos", label: "Arándanos frescos"},
    { id: "arandanospasa", label: "Pasas de arándano" },
    { id: "banana", label: "Banana" },
    { id: "nueces", label: "Nueces" },
    { id: "canela", label: "Canela" },
    { id: "tiramisu", label: "Tiramisú", notWith: ["*"] },
    { id: "tortadelimon", label: "Torta de limón", notWith: ["*"] },
  ],
  acidez: ["Suave", "Ácido"],
  textura: ["Suave", "Cremoso"],
  grasas: ["Descremado", "Medio", "Extra"],
  limits: { maxToppings: 5 },
  whatsapp: {
    // Change this number to your WhatsApp business number (with country code, no + sign)
    phoneNumber: "59899103817",
    businessName: "miyogur Lab",
  },
};

// Backwards compatibility alias. Prefer importing DEFAULT_CATALOG.
export const CATALOG = DEFAULT_CATALOG;

export const DEFAULT_WHATSAPP_CONFIG = DEFAULT_CATALOG.whatsapp;
